/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface A
 */
export interface A {
    /**
     * 
     * @type {string}
     * @memberof A
     */
    d?: string;
    /**
     * 
     * @type {string}
     * @memberof A
     */
    i?: string;
    /**
     * 
     * @type {string}
     * @memberof A
     */
    dt?: string;
    /**
     * 
     * @type {number}
     * @memberof A
     */
    loa?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof A
     */
    lids?: Array<string>;
}

/**
 * Check if a given object implements the A interface.
 */
export function instanceOfA(value: object): boolean {
    return true;
}

export function AFromJSON(json: any): A {
    return AFromJSONTyped(json, false);
}

export function AFromJSONTyped(json: any, ignoreDiscriminator: boolean): A {
    if (json == null) {
        return json;
    }
    return {
        
        'd': json['d'] == null ? undefined : json['d'],
        'i': json['i'] == null ? undefined : json['i'],
        'dt': json['dt'] == null ? undefined : json['dt'],
        'loa': json['loa'] == null ? undefined : json['loa'],
        'lids': json['lids'] == null ? undefined : json['lids'],
    };
}

export function AToJSON(value?: A | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'd': value['d'],
        'i': value['i'],
        'dt': value['dt'],
        'loa': value['loa'],
        'lids': value['lids'],
    };
}

